module.exports = {
  dashboard: '/app/home',
  login: '/login',
  profile: '/app/user/profile',
  my_projects: '/app/projects-list',
  primaryContact: '/app/user/primary-contact',
  walletAndPayments: '/app/user/wallet-and-payments',
  documents: '/app/user/documents',
  notifications: '/app/user/notifications',
};
